import { Box, Typography } from '@mui/material'

import CustdevForm from '../components/settings/CustdevForm'

export default function CustdevPage() {
  return <Box sx={{ p: { xs: 2, sm: 3, lg: 4 }, width: '100%', maxWidth: 1184, boxSizing: 'border-box' }}>
    <Typography variant="h4" component="h1" sx={{ mb: 1, textWrap: 'balance' }}>Custdev interviews</Typography>
    <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>Choose who receives an interview invitation and where they book.</Typography>
    <CustdevForm />
  </Box>
}
